/**
 * Configuration for the application.
 * 
 * This file centralizes environment variable access and provides
 * safe defaults.
 */

// Supabase configuration
export const SUPABASE_URL =
  import.meta.env.VITE_SUPABASE_URL ||
  (typeof process !== "undefined" && (process as any).env?.VITE_SUPABASE_URL) ||
  "";

export const SUPABASE_ANON_KEY =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  (typeof process !== "undefined" && (process as any).env?.VITE_SUPABASE_ANON_KEY) ||
  "";

// Cloudflare Turnstile configuration
// This is a public site key, but we treat it as an environment variable
// to allow for different keys in different environments (dev/prod).
export const TURNSTILE_SITE_KEY =
  import.meta.env.VITE_TURNSTILE_SITE_KEY ||
  (typeof process !== "undefined" && (process as any).env?.VITE_TURNSTILE_SITE_KEY) ||
  "";

// App metadata
export const APP_NAME = import.meta.env.VITE_APP_NAME || "Εν Πλω";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "1.0.0";

// Business Information (for display and communication)
export const BUSINESS_NAME = "Εν Πλω";
export const BUSINESS_FULL_NAME = "Εν Πλω στο καφενείο του ψαρά";
export const BUSINESS_ADDRESS = "Νικ. Πλαστήρα 14Β, Καλαμαριά 551 32";
export const BUSINESS_PHONE = "+30 2310 123456"; // Update with actual phone
export const BUSINESS_WEBSITE = "https://www.instagram.com/enplo_/";
export const BUSINESS_INSTAGRAM = "https://www.instagram.com/enplo_/";
export const BUSINESS_FACEBOOK = "https://www.facebook.com/profile.php?id=100063455146116";
export const BUSINESS_GOOGLE_MAPS = "https://maps.app.goo.gl/R8CLfmxv5Yo9odsQ9";

// Feature flags
export const IS_DEV = import.meta.env.DEV;
export const IS_PROD = import.meta.env.PROD;
export const DEBUG_MODE = import.meta.env.VITE_DEBUG_MODE === "true";

/**
 * Emails allowed to see the multi-tenant restaurant picker (e.g. developer/admin).
 * Client accounts are assigned to a single restaurant and must never see other restaurants.
 * Comma-separated, e.g. "dev@example.com,nastosalex4@gmail.com"
 */
export const MULTI_TENANT_PICKER_ALLOWED_EMAILS: string[] = (
  import.meta.env.VITE_MULTI_TENANT_PICKER_ALLOWED_EMAILS ||
  (typeof process !== "undefined" && (process as any).env?.VITE_MULTI_TENANT_PICKER_ALLOWED_EMAILS) ||
  ""
)
  .split(",")
  .map((s: string) => s.trim().toLowerCase())
  .filter(Boolean);
